import PropTypes from 'prop-types'
import React from 'react'
import { Typography } from '@mui/material'
import UnfoldMore from '@mui/icons-material/UnfoldMoreOutlined'
import esLocale from 'date-fns/locale/es'
import format from 'date-fns/format'
import clsx from 'clsx'

const DateFieldToolbar = ({ value, view, onViewChange, className }) => {
  const date = value || new Date()
  const dateEs = format(date, 'EEE, dd MMM', { locale: esLocale })
  const isYearView = view === 'year'
  const isDateView = view === 'day'

  return (
    <div className={clsx('flex flex-col items-start bg-blue-700 datepicker-toolbar px-6 py-4', className)}>
      <button
        type="button"
        onClick={() => onViewChange('year')}
        className={clsx(
          'flex items-center text-white hover:bg-black hover:bg-opacity-30 px-2 rounded-lg -ml-2',
          !isYearView && 'text-opacity-70'
        )}
      >
        <Typography variant="h6" component="span" color="inherit">
          {date.getFullYear()}
        </Typography>
        <UnfoldMore className="text-white ml-1" fontSize="small" />
      </button>
      <button
        type="button"
        onClick={() => onViewChange('day')}
        className={clsx('text-white mt-1', !isDateView && 'text-opacity-90')}
      >
        <Typography variant="h4" component="span" color="inherit">
          {dateEs}
        </Typography>
      </button>
    </div>
  )
}

export default DateFieldToolbar

DateFieldToolbar.propTypes = {
  value: PropTypes.instanceOf(Date),
  view: PropTypes.string,
  onViewChange: PropTypes.func,
  className: PropTypes.string
}
